import { COLORS } from '@btime/constants'
import React, { useCallback } from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { getQueryParam } from '../../../../../utils/helpers/url'
import { useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import { useIsDraggingType } from '../../../../../components/dnd/DndHandler'
import CategoryActions from './CategoryActions'
import Center from '../../../../../components/helpers/Center'
import Draggable from '../../../../../components/dnd/Draggable'
import Droppable from '../../../../../components/dnd/Droppable'
import Icon from '../../../../../packages/kiti/components/shapes/Icon'
import QuestionsList from '../questions/QuestionsList'
import SelectOrTitleCategory from './SelectOrTitleCategory'
import Separator from '../../../../../components/helpers/Separator'
import dndTypes from '../_constants/dndTypes'

const CategoryPanel = ({ category, index }) => {
  const [open, setOpen] = React.useState(getQueryParam('startsClosed') !== 'true')
  const isDragging = useIsDraggingType(dndTypes.CATEGORY)

  const { moveElementCloseTo } = useChecklistFormActions()

  const onDrop = useCallback((item, dir) => {
    moveElementCloseTo(item.reference, category.reference, dir)
  })

  return (
    <Droppable type={dndTypes.CATEGORY} onDrop={onDrop} placeholderWeight={12}>
      <Draggable item={category} type={dndTypes.CATEGORY} hideOnDrag>
        {!!isDragging && <Separator weight={4} />}
        <Grid align="center" justify="flex-between" gutter={0.4} marginLeft={-2}>
          <Icon name={open ? 'BsCaretDownSquare' : 'BsCaretRightSquare'} color="dark3" onClick={() => setOpen(!open)} />
          <div style={{ cursor: 'move' }}>
            <Center>
              <Icon name="BsArrowsMove" color={COLORS.dark3} />
            </Center>
          </div>

          <Col flex={1}>
            <SelectOrTitleCategory category={category} index={index} />
          </Col>

          <CategoryActions category={category} index={index} />
        </Grid>
      </Draggable>

      {open && !isDragging && <Separator weight={2} />}
      {open && !isDragging && <QuestionsList questions={category.children} parentReference={category.reference} />}

      <Separator weight={4} />
    </Droppable>
  )
}

export default CategoryPanel
